export const Footer = () => {
  return <div>© Grupo Unico C.A. J-30913093-5</div>;
};
